import { apiGet, apiPatch } from './client';
import type {
  AssetTypeDefaultValue,
  AssetTypeDefaultValueBatchRequest,
} from '../types/AssetTypeDefaultValue';

export function getAssetTypeDefaultValues(): Promise<AssetTypeDefaultValue[]> {
  return apiGet<AssetTypeDefaultValue[]>('/api/asset-type-default-values');
}

export function saveAssetTypeDefaultValuesBatch(
  added: AssetTypeDefaultValue[],
  modified: AssetTypeDefaultValue[],
  deletedIds: number[],
): Promise<AssetTypeDefaultValue[]> {
  return apiPatch<AssetTypeDefaultValueBatchRequest, AssetTypeDefaultValue[]>(
    '/api/asset-type-default-values/batch',
    { added, modified, deleted: deletedIds },
  );
}
